import React from 'react';
import FeatureCard from './FeatureCard';

const FeaturesGrid = () => {
  const features = [
    {
      title: 'Etkinlikler',
      description: 'En güncel turlar ve eğitimler.',
      icon: 'Calendar',
      link: '/event-discovery',
      gradient: 'from-blue-500 to-cyan-500',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      title: 'Mağaza',
      description: 'Profesyonel ekipmanlar.',
      icon: 'ShoppingBag',
      link: '/official-store',
      gradient: 'from-purple-500 to-pink-500',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600'
    },
    {
      title: 'Spot Rehberi',
      description: 'En iyi rotaları keşfet.',
      icon: 'MapPin',
      link: '/spot-guide',
      gradient: 'from-green-500 to-teal-500',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      title: 'İkinci El',
      description: 'Ekipman al/sat.',
      icon: 'Store',
      link: '/user-marketplace',
      gradient: 'from-orange-500 to-red-500',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600'
    },
    {
      title: 'Blog',
      description: 'Yazılar ve ipuçları.',
      icon: 'BookOpen',
      link: '/blog-listing',
      gradient: 'from-teal-500 to-cyan-500',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Platform Özellikleri
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Kürek sörfü tutkunları için tasarlanmış kapsamlı hizmetler
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {features?.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;